import { Component } from 'react';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {NavLink} from 'react-router-dom';
import { userAddressesFetched } from '../../../redux/actions/addressAction';
import building from '../../../assets/img/building.jpeg';
import { setSearchData, setFullSearchData } from '../../../redux/actions/searchAction';
import lodash from 'lodash'

class BuildingOverview extends Component {
    constructor(props) {
        super(props);
        this.setShowBuildings = this.setShowBuildings.bind(this);
        this._getData = this._getData.bind(this);
        this.reOrderBuildings = this.reOrderBuildings.bind(this);
        this.state = {
            buildingsCollapsed : false,
            displayAddresses : []
        }

        this.firstRendered = false;
    }

    componentDidMount() {

        this.props.setFullSearchData(this.props.addresses);

        if(!this.props.searchData.fullSearchData.length) {
            this.props.updateSearchData(this.props.addresses);
        }

        if(!this.props.addresses)
        {
             this.props.userAddressesFetched(this.props.user.user_profile.addresses)
        }
        if(this.props.match.params.id) {
            this.reOrderBuildings(this.props.match.params.id);
        }
    }

    componentWillUnmount() {
        this.props.setFullSearchData(false);
    }
    componentDidUpdate(prevProps) {
        //this.props.updateSearchData(this.props.addresses);

        if ( JSON.stringify(this.props.searchData.data) !== JSON.stringify(prevProps.searchData.data) ) {
            this.reOrderBuildings(this.props.match.params.id);
        }
    }


    _getUnreadCount(messages) {
        let unreadCount = 0;
        for(let i = 0; i <= messages.length; i++) {
            if(messages[i]) {
               if(messages[i]['has_been_read'] === '0') {
                    if(messages[i]['is_priority'] === '1') {
                        unreadCount++;
                    }
                }
            }
        }

        return unreadCount;

    }

    _orderAddressesByUrgentMessages = (addresses) => {
        let withUrgent = [];
        let withoutUrgent = [];

        addresses.forEach((item, i) => {
            let unreadCount = 0;
            if(this.props.messages.data) {
                let filterable = this.props.messages.data;
                if ( filterable.data ) {
                    filterable = filterable.data;
                }
                const messages = filterable.filter( message => message.dp_address_id === item.dp_address_id);

                if(messages) {
                    unreadCount = this._getUnreadCount(messages);
                    item.unreadCount = unreadCount;
                }
            }

            if ( unreadCount ) {
                withUrgent.push(item);
            } else {
                withoutUrgent.push(item);
            }
        });


        withUrgent.sort(this._sortByUnreadCount);
        let newAddresses = [
            ...withUrgent,
            ...withoutUrgent
        ]


        return newAddresses;
    }

    _sortByUnreadCount( a, b ) {
      if ( a.unreadCount > b.unreadCount ){
        return -1;
      }
      if ( a.unreadCount < b.unreadCount ){
        return 1;
      }
      return 0;
    }

    reOrderBuildings(dp_address_id) {
        let addresses = [];
        if(this.props.searchData.data) {
            addresses = this.props.searchData.data;
        }else{
            addresses = this.props.addresses;
        }
        if(addresses) {

            let newAddresses = [];
            const addressIndex = lodash.findIndex(addresses, function(value, dp_address_id) { return value ? value.dp_address_id === dp_address_id : false; });
            if(addressIndex) {

                const building = addresses.find(e => (e != null ? e.dp_address_id === dp_address_id : false));
               // const building = lodash.findIndex(addresses, function(value, dp_address_id) { return value ? value.dp_address_id === dp_address_id : false; });
                delete addresses[addressIndex];

                addresses = this._orderAddressesByUrgentMessages(addresses);
                newAddresses = [building, ...addresses];

                this.setState({
                    displayAddresses: newAddresses
                })
            }
        }
    }
    mapAddresses(key, item) {
        let unreadCount = 0;
        if(!item)
            return null;

        if(item.dp_address_id === this.props.match.params.id) {
            if(key > 0) {
                return;
            }
        }

        if(this.props.messages.data) {
            let filterable = this.props.messages.data;
            if ( filterable.data ) {
                filterable = filterable.data;
            }
            const messages = filterable.filter( message => message.dp_address_id === item.dp_address_id);

            if(messages) {
                unreadCount = this._getUnreadCount(messages);
            }
        }
        const address = this.props.addresses.find( address => address ? address.dp_address_id === item.dp_address_id : false );
        if(address) {
            const image = address.address_image ? address.address_image : "https://mijndp.dp.nl/image/api/building.jpeg";
            return(
                <NavLink className="single__item__link" to={"/adressen/bekijken/" + item.dp_address_id} key={key}>

                    <li className={this.props.match.params.id && this.props.match.params.id === item.dp_address_id ? 'active__address single__address' : 'single__address'}>
                        <div className="address__image" style={{backgroundImage: 'url(' + image + ')'}}>

                        </div>
                        <div className="address__name">
                            {unreadCount ? <span className="unread__message__badge">{unreadCount}</span> : null}
                            <div className="address_street">{item.street}</div>
                        </div>
                    </li>
                </NavLink>
            )
         }
    }

    setShowBuildings(e) {
        e.preventDefault();

        var section = document.querySelector('.hidden__list');
        var isCollapsed = !this.state.buildingsCollapsed;
        this.setState({
            buildingsCollapsed: !this.state.buildingsCollapsed
        })
        if(isCollapsed) {
            window.Avantage.Expand(section)

        } else {
            window.Avantage.Collapse(section)
        }
    }

    _getData() {
        return this.state.displayAddresses;
    }

    render() {

        const arraySize = this._getData().length;
        const start = 0;
        const end = 10;
        return (

            <div className="card card--margin-top-10">

               {arraySize > 10 ? <a className="building__toggler" onClick={this.setShowBuildings}>{!this.state.buildingsCollapsed ? <span>Toon alle adressen</span> : <span>Toon minder adressen</span>}</a> : null}
                <ul className={"building__list building__list--addresses building__list--unmarged "}>
                    {this._getData() && this.props.addresses ? this._getData().slice(start, end).map((item, key) => this.mapAddresses(key, item)) : null}
                    {arraySize === 0 ? <p>Geen resultaten</p> : null}
                    <span className="hidden__list collapsible">
                        {this._getData() ? this._getData().slice(end, arraySize).map((item, key) => this.mapAddresses(key, item)) : ''}
                    </span>
                </ul>
            </div>


        );
    }
}

function mapStateToProps(state) {
  return {
    addresses: state.AddressReducer.addresses,
     user: state.UserReducer,
     messages: state.messagesReducer.messages,
     searchData: state.SearchDataReducer
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
        userAddressesFetched: (addresses) => dispatch(userAddressesFetched(addresses)),
        updateSearchData: (data) => dispatch(setSearchData(data)),
        setFullSearchData: (component) => dispatch(setFullSearchData(component))
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps, false, {pure: false})(BuildingOverview));



// WEBPACK FOOTER //
// ./src/components/Addresses/BuildingOverview/index.js